import { configureStore } from "@reduxjs/toolkit";
import authReducer from "../features/auth/authSlice";
import formReducer from "../components/Incidents/NewIncident/formSlice";
import { apiSlice } from "./api/apiSlice";

export const store = configureStore({
  reducer: {
    [apiSlice.reducerPath]: apiSlice.reducer,
    auth: authReducer,
    form: formReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(apiSlice.middleware),
  devTools: true,
});
